import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

function ZiyaretciForm({ userRole }) {
  const [formData, setFormData] = useState({
    ad_soyad: '',
    firma_id: '',
    yeni_firma: '',
    ziyaret_turu: 'firma',
    arac_var: false,
    plaka: '',
    birim_id: '',
    personel_id: '',
    aciklama: ''
  });

  const [birimler, setBirimler] = useState([]);
  const [personeller, setPersoneller] = useState([]);
  const [firmalar, setFirmalar] = useState([]);
  const [bugunZiyaretciler, setBugunZiyaretciler] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchBirimler();
    fetchFirmalar();
    fetchBugunZiyaretciler();
    
    const interval = setInterval(fetchBugunZiyaretciler, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (formData.birim_id) {
      fetchPersoneller(formData.birim_id);
    }
  }, [formData.birim_id]);

  useEffect(() => {
    if (formData.ziyaret_turu === 'is_basvuru') {
      const ikBirim = birimler.find(b => 
        b.birim_adi.toLowerCase().includes('ik') || 
        b.birim_adi.toLowerCase().includes('insan kaynakları') ||
        b.birim_adi.toLowerCase().includes('İK')
      );
      if (ikBirim) {
        setFormData(prev => ({ ...prev, birim_id: ikBirim.id }));
      }
    }
  }, [formData.ziyaret_turu, birimler]);

  const fetchBirimler = async () => {
    try {
      const response = await api.get('/birimler');
      setBirimler(response.data);
    } catch (error) {
      console.error('Birimler yüklenemedi:', error);
    }
  };

  const fetchPersoneller = async (birimId) => {
    try {
      const response = await api.get(`/personeller/birim/${birimId}`);
      setPersoneller(response.data);
    } catch (error) {
      console.error('Personeller yüklenemedi:', error);
    }
  };

  const fetchFirmalar = async () => {
    try {
      const response = await api.get('/firmalar');
      setFirmalar(response.data);
    } catch (error) {
      console.error('Firmalar yüklenemedi:', error);
    }
  };

  const fetchBugunZiyaretciler = async () => {
    try {
      const today = new Date();
      const baslangic = new Date(today.setHours(0, 0, 0, 0)).toISOString();
      const bitis = new Date(today.setHours(23, 59, 59, 999)).toISOString();
      
      const response = await api.get(`/ziyaretciler/rapor?baslangic=${baslangic}&bitis=${bitis}`);
      setBugunZiyaretciler(response.data);
    } catch (error) {
      console.error('Bugünün ziyaretçileri yüklenemedi:', error);
    }
  };

  const handleCikis = async (id) => {
    if (window.confirm('Çıkış zamanı kaydedilsin mi?')) {
      try {
        await api.put(`/ziyaretciler/${id}/cikis`);
        fetchBugunZiyaretciler();
        alert('Çıkış zamanı kaydedildi');
      } catch (error) {
        alert('Hata: ' + (error.response?.data?.error || 'İşlem başarısız'));
      }
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);

    try {
      let firmaId = formData.firma_id;
      
      if (formData.yeni_firma && formData.ziyaret_turu === 'firma') {
        const firmaResponse = await api.post('/firmalar', { 
          firma_adi: formData.yeni_firma 
        });
        firmaId = firmaResponse.data.data.id;
        await fetchFirmalar();
      }

      const ziyaretciData = {
        ad_soyad: formData.ad_soyad,
        firma_id: formData.ziyaret_turu === 'firma' ? firmaId : null,
        ziyaret_turu: formData.ziyaret_turu,
        arac_var: formData.arac_var,
        plaka: formData.arac_var ? formData.plaka : null,
        birim_id: formData.birim_id || null,
        personel_id: formData.personel_id || null,
        aciklama: formData.aciklama || null
      };

      await api.post('/ziyaretciler', ziyaretciData);
      
      setSuccess(true);
      setFormData({
        ad_soyad: '',
        firma_id: '',
        yeni_firma: '',
        ziyaret_turu: 'firma',
        arac_var: false,
        plaka: '',
        birim_id: '',
        personel_id: '',
        aciklama: ''
      });
      setPersoneller([]);
      
      fetchBugunZiyaretciler();
      
      setTimeout(() => setSuccess(false), 3000);
      
    } catch (error) {
      alert('Kayıt başarısız: ' + (error.response?.data?.error || 'Hata oluştu'));
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/';
  };

  const formatTime = (date) => {
    if (!date) return '-';
    return new Date(date).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
  };

  const getZiyaretDurumu = (cikis) => {
    return cikis ? '✅ Çıkış Yaptı' : '🔴 İçeride';
  };

  return (
    <div className="container">
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
        <div>
          {userRole === 'admin' && (
            <button 
              onClick={() => navigate('/admin/dashboard')}
              className="btn btn-secondary"
            >
              📊 Yönetim Paneli
            </button>
          )}
        </div>
        <button 
          onClick={handleLogout}
          className="btn btn-primary"
        >
          🚪 Çıkış Yap
        </button>
      </div>

      <div className="card slide-in">
        <h2 style={{ color: '#ff0000', marginBottom: '20px' }}>Ziyaretçi Kayıt Formu</h2>
        
        {success && (
          <div style={{ 
            backgroundColor: '#ccffcc', 
            color: '#006600', 
            padding: '15px', 
            borderRadius: '5px',
            marginBottom: '20px',
            border: '2px solid #00cc00',
            animation: 'fadeIn 0.5s ease-in'
          }}>
            ✅ Ziyaretçi başarıyla kaydedildi!
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Ad Soyad *</label>
            <input
              type="text"
              name="ad_soyad"
              value={formData.ad_soyad}
              onChange={handleChange}
              required
              placeholder="Ziyaretçinin adı soyadı"
            />
          </div>

          <div className="form-group">
            <label>Ziyaret Türü *</label>
            <select
              name="ziyaret_turu"
              value={formData.ziyaret_turu}
              onChange={handleChange}
              required
            >
              <option value="firma">Firma</option>
              <option value="is_basvuru">İş Başvurusu</option>
              <option value="arkadas">Arkadaş</option>
              <option value="gorevli">Görevli</option>
            </select>
          </div>

          {formData.ziyaret_turu === 'firma' && (
            <>
              <div className="form-group">
                <label>Firma</label>
                <select
                  name="firma_id"
                  value={formData.firma_id}
                  onChange={handleChange}
                >
                  <option value="">-- Listeden Seçin --</option>
                  {firmalar.map(firma => (
                    <option key={firma.id} value={firma.id}>
                      {firma.firma_adi}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Veya Yeni Firma Ekle</label>
                <input
                  type="text"
                  name="yeni_firma"
                  value={formData.yeni_firma}
                  onChange={handleChange}
                  placeholder="Yeni firma adı yazın"
                />
              </div>
            </>
          )}

          <div className="checkbox-group">
            <input
              type="checkbox"
              name="arac_var"
              checked={formData.arac_var}
              onChange={handleChange}
            />
            <label>Araç var mı?</label>
          </div>

          {formData.arac_var && (
            <div className="form-group">
              <label>Plaka</label>
              <input
                type="text"
                name="plaka"
                value={formData.plaka}
                onChange={handleChange}
                placeholder="Örn: 34 ABC 123"
              />
            </div>
          )}

          <div className="form-group">
            <label>Ziyaret Edilecek Birim</label>
            <select
              name="birim_id"
              value={formData.birim_id}
              onChange={handleChange}
            >
              <option value="">-- Birim Seçin --</option>
              {birimler.map(birim => (
                <option key={birim.id} value={birim.id}>
                  {birim.birim_adi}
                </option>
              ))}
            </select>
          </div>

          {formData.birim_id && (
            <div className="form-group">
              <label>Ziyaret Edilecek Kişi</label>
              <select
                name="personel_id"
                value={formData.personel_id}
                onChange={handleChange}
              >
                <option value="">-- Personel Seçin --</option>
                {personeller.map(personel => (
                  <option key={personel.id} value={personel.id}>
                    {personel.ad_soyad} {personel.gorev && `- ${personel.gorev}`}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="form-group">
            <label>Açıklama (Opsiyonel)</label>
            <textarea
              name="aciklama"
              value={formData.aciklama}
              onChange={handleChange}
              rows="3"
              placeholder="Ek bilgiler..."
            />
          </div>

          <button 
            type="submit" 
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? 'Kaydediliyor...' : 'Kaydet'}
          </button>
        </form>
      </div>

      {/* BUGÜNÜN ZİYARETÇİ LİSTESİ */}
      <div className="card" style={{ marginTop: '30px', animation: 'slideIn 0.8s ease-out' }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          marginBottom: '20px'
        }}>
          <h2 style={{ color: '#ff0000', margin: 0 }}>
            📋 Bugünün Ziyaretçileri
          </h2>
          <div style={{ 
            backgroundColor: '#ff0000', 
            color: '#fff', 
            padding: '8px 16px', 
            borderRadius: '20px',
            fontWeight: 'bold',
            animation: 'pulse 2s infinite'
          }}>
            {bugunZiyaretciler.length} Ziyaretçi
          </div>
        </div>

        {bugunZiyaretciler.length === 0 ? (
          <div style={{ 
            textAlign: 'center', 
            padding: '40px', 
            color: '#666',
            fontSize: '18px'
          }}>
            Bugün henüz ziyaretçi kaydı yok
          </div>
        ) : (
          <div style={{ 
            display: 'grid', 
            gap: '15px',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))'
          }}>
            {bugunZiyaretciler.map((z, index) => (
              <div 
                key={z.id}
                style={{
                  backgroundColor: z.cikis_zamani ? '#f9f9f9' : '#ffe6e6',
                  border: `3px solid ${z.cikis_zamani ? '#ccc' : '#ff0000'}`,
                  borderRadius: '12px',
                  padding: '20px',
                  position: 'relative',
                  overflow: 'hidden',
                  animation: `fadeIn 0.5s ease-in ${index * 0.1}s backwards`,
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 25px rgba(255, 0, 0, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  backgroundColor: z.cikis_zamani ? '#28a745' : '#ff0000',
                  color: '#fff',
                  padding: '4px 12px',
                  borderRadius: '15px',
                  animation: z.cikis_zamani ? 'none' : 'pulse 2s infinite'
                }}>
                  {getZiyaretDurumu(z.cikis_zamani)}
                </div>

                <div style={{ 
                  fontSize: '20px', 
                  fontWeight: 'bold', 
                  color: '#000',
                  marginBottom: '10px',
                  marginTop: '20px'
                }}>
                  👤 {z.ad_soyad}
                </div>

                {z.firma_adi && (
                  <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>
                    🏢 {z.firma_adi}
                  </div>
                )}
                <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>
                  📌 {z.ziyaret_turu}
                </div>

                {z.birim_adi && (
                  <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>
                    🏛️ {z.birim_adi}
                  </div>
                )}
                {z.personel_adi && (
                  <div style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>
                    👔 {z.personel_adi}
                  </div>
                )}

                <div style={{ 
                  marginTop: '15px', 
                  paddingTop: '15px', 
                  borderTop: '2px solid #ff0000',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center'
                }}>
                  <div>
                    <div style={{ fontSize: '12px', color: '#666' }}>Giriş</div>
                    <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#ff0000' }}>
                      ⏰ {formatTime(z.gelis_zamani)}
                    </div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: '12px', color: '#666' }}>Çıkış</div>
                    <div style={{ fontSize: '16px', fontWeight: 'bold', color: z.cikis_zamani ? '#28a745' : '#999' }}>
                      {z.cikis_zamani ? `⏰ ${formatTime(z.cikis_zamani)}` : '-'}
                    </div>
                  </div>
                </div>

                {/* Çıkış butonu - sadece çıkış yapmamışlar için */}
                {!z.cikis_zamani && (
                  <button 
                    onClick={() => handleCikis(z.id)}
                    className="btn btn-primary"
                    style={{ 
                      width: '100%', 
                      marginTop: '15px',
                      fontSize: '14px',
                      padding: '10px'
                    }}
                  >
                    ✅ Çıkış Yap
                  </button>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ZiyaretciForm;
